import { CustomerAggregations } from '@src/containers/Dealer/CustomerAggregations';
import type { CustomerAggregationsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

/**
 * We purposefully do not add the legacy component to this panel.
 */
export function CustomerAggregationsPanel({ api, params }: LayoutPanelProps<CustomerAggregationsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-aggregations-panel"
    >
      <CustomerAggregations />
    </EntityAdminPanelShell>
  );
}
